import { render } from "./AwayHome.vue?vue&type=template&id=5abe11a6&scoped=true"
import script from "./AwayHome.vue?vue&type=script&lang=js"
export * from "./AwayHome.vue?vue&type=script&lang=js"

import "./AwayHome.vue?vue&type=style&index=0&id=5abe11a6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5abe11a6"]])

export default __exports__